import { useColorMode, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SelectionCell, SheetSelection } from '../types';
import { inRange } from '../../core/utils/general/general';
import { hexToRGB } from '../../core/utils/view';
import { useCallback } from 'react';

type GetHeaderFill = {
  fill: string;
  textColor: string;
  isSelected: boolean;
  isActiveSelection: boolean;
  underSelection: boolean;
};
export interface UseSheetTheme {
  isRtl: boolean;
  fill: string;
  secondaryFill: string;
  filterAppliedFill: string;
  stroke: string;
  textColor: string;
  selectionBorder: string;
  selectionFill: string;
  extendCircleBorderColor: string;
  extendSelectionBorderColor: string;
  isDarkTheme: boolean;

  getHeaderFill: (
    selections: SheetSelection[],
    index: number,
    headerCell: SelectionCell.Column | SelectionCell.Row,
    filtered?: boolean
  ) => GetHeaderFill;
}
export default (): UseSheetTheme => {
  const { i18n } = useTranslation();
  const dir = i18n.dir();
  const fill = useColorModeValue('#fff', '#121212'); //  '#f1f5f8', '#161718'
  const secondaryFill = useColorModeValue('#f1f5f8', '#161718');
  const stroke = useColorModeValue('#dfdfdf', '#2a2a2a'); //f1f5f8  /#
  const textColor = useColorModeValue('#000', '#fff');
  const filterAppliedFill = useColorModeValue('#ebfcf2', '#0c291f'); // Og light:  cdf7df Dark : 144533

  const selectionBorder = useColorModeValue('#007BFF', '#3C82E7');
  const selectionFill = useColorModeValue('#3395ff', '#3395ff'); //2a5ba2
  const selectionIndicator = useColorModeValue('#d6eaff', '#0f2d4c');

  const extendCircleBorderColor = useColorModeValue('#fff', '#121212');
  const extendSelectionBorderColor = useColorModeValue('#121212', '#fff');

  const { colorMode } = useColorMode();
  const isDarkTheme = colorMode === 'dark';

  const getHeaderFill = useCallback(
    (
      selections: SheetSelection[],
      index: number,
      headerCell: SelectionCell.Column | SelectionCell.Row,
      filtered?: boolean
    ) => {
      let isSelected = false;
      let underSelection = false;
      let isActiveSelection = false;
      let background = filtered ? filterAppliedFill : fill;
      const alias = headerCell === SelectionCell.Row ? 'ri' : 'ci';
      for (let i = 0; i < selections.length; i++) {
        const { cell, area } = selections[i];
        const areaStart = area.start[alias];
        const areaEnd = area.end[alias];
        if (inRange(index, areaStart, areaEnd)) {
          underSelection = true;
          if (cell === headerCell) {
            isSelected = true;
            background = selectionBorder;
            isActiveSelection = i === selections.length - 1;
            break;
          }
          background = selectionIndicator; //hexToRGB(selectionFill, 0.2);
        }
      }

      return {
        fill: background,
        isSelected,
        underSelection,
        isActiveSelection,
        textColor: isSelected ? '#fff' : textColor,
      };
    },
    [selectionBorder, selectionFill, textColor]
  );

  return {
    isRtl: dir === 'rtl',
    fill,
    secondaryFill,
    filterAppliedFill,
    stroke,
    textColor,
    selectionFill,
    selectionBorder,
    extendCircleBorderColor,
    extendSelectionBorderColor,
    getHeaderFill,
    isDarkTheme,
  };
};
